module.exports = __webpack_public_path__ + "static/media/hacker.177e9802.jpg";